import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import DownloadTheAppFooter from "@components/feedComponents/DownloadTheAppFooter";
import FeedCard from "@components/feedComponents/FeedCard";
import NoSnacksFound from "@components/feedComponents/NoSnacksFound";
import Loading from "@components/loadingComponents/BouncingLoader";

export default function PersonalFeed({ userFeedData }) {
  const { data, fetchMore, nextVariablesExtractor, resultsExtractor } =
    userFeedData;

  const [fetchingMore, setFetchingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const posts = resultsExtractor(userFeedData.data);

  // fetch more data function.
  async function fetchMoreData() {
    if (!fetchingMore) {
      setFetchingMore(true);
      const nextVariables = nextVariablesExtractor(data);
      const variables = JSON.parse(
        JSON.stringify(nextVariables, (k, v) =>
          k === "__typename" ? undefined : v
        )
      );
      variables.cursors.limit = 10;

      const morePosts = await fetchMore({ variables });

      if (!morePosts.data.getFeed.posts.length) {
        setHasMore(false);
      }

      setFetchingMore(false);
    }
  }

  if (!posts.length) return <NoSnacksFound />;

  return (
    <InfiniteScroll
      dataLength={posts.length}
      next={() => fetchMoreData()}
      hasMore={hasMore}
      endMessage={<DownloadTheAppFooter />}
      scrollThreshold={0.7}
    >
      <div className="w-full flex flex-col mt-6 justify-center items-center lg:grid lg:grid-cols-3 lg:gap-x-8 lg:gap-y-10">
        {posts.map((post) => (
          <FeedCard post={post} key={post.id} />
        ))}
      </div>
      {fetchingMore && <Loading />}
    </InfiniteScroll>
  );
}
